import React from 'react';
import { Typography, Box } from '@mui/material';

const Rank: React.FC = () => {
  return (
    <div className="rank-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Ranking
      </Typography>
      <Box>
        <Typography variant="body1">
          Página de ranking em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default Rank; 